import React, { Component } from "react";
import PropTypes from "prop-types";

import { DragDropContext } from "react-beautiful-dnd";

import VariablesGroup from "./VariablesGroup";
import styles from "./selected-variables-list.module.scss";

class SelectedVariablesList extends Component {
  reorderVariables = ({ variablesGroups, source, destination }) => {
    const reorder = (list = [], startIndex, endIndex) => {
      const result = [...list];
      const removed = result.splice(startIndex, 1);
      result.splice(endIndex, 0, ...removed);

      return result;
    };

    const current = [...variablesGroups[source.droppableId]];
    const next = [...variablesGroups[destination.droppableId]];
    const target = current[source.index];

    if (source.droppableId === destination.droppableId) {
      const reordered = reorder(current, source.index, destination.index);
      const newVariablesGroups = [...variablesGroups];

      newVariablesGroups[+destination.droppableId] = reordered;

      const result = newVariablesGroups;
      return result;
    }

    current.splice(source.index, 1);
    next.splice(destination.index, 0, target);

    const newVariablesGroups = [...variablesGroups];

    newVariablesGroups[source.droppableId] = current;
    newVariablesGroups[destination.droppableId] = next;

    const result = newVariablesGroups;
    return result;
  };

  onDragEnd = ({ destination, source }) => {
    // dropped outside the list
    if (!destination) {
      return;
    }

    const { onReorder, dndVariables } = this.props;
    onReorder(
      this.reorderVariables({
        variablesGroups: dndVariables,
        source,
        destination
      })
    );
  };

  render() {
    const { dndVariables, onRemoveVariable, onRemoveGroup } = this.props;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <div className={styles["variables-groups-list"]}>
          {dndVariables.map((group, index) => {
            return (
              <VariablesGroup
                key={`vargroup${group.length ? group[0].id : index}`}
                listId={index}
                listType="CARD"
                listLength={dndVariables.length}
                group={group}
                groupId={index}
                onRemoveVariable={onRemoveVariable}
                onRemoveGroup={onRemoveGroup}
              />
            );
          })}
        </div>
      </DragDropContext>
    );
  }
}

SelectedVariablesList.propTypes = {
  dndVariables: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({})))
    .isRequired,
  onReorder: PropTypes.func.isRequired,
  onRemoveVariable: PropTypes.func.isRequired,
  onRemoveGroup: PropTypes.func.isRequired
};

export default SelectedVariablesList;
